<template>
    <div class="fleet-onboarding">
        <fleet-setup-side-bar :section="currentSection" @change-section="changeSection"></fleet-setup-side-bar>

        <main class="content">
            <header class="onboarding-header">
                <fleet-setup-step-title :section="currentSection"></fleet-setup-step-title>
                <fleet-setup-progress-tracker :section="currentSection"></fleet-setup-progress-tracker>
            </header>

            <!-- Main logic content for section -->
            <fleet-setup-team-setup v-if="currentSection == 'team'"></fleet-setup-team-setup>
            <fleet-setup-favorites-setup v-if="currentSection == 'favorites'"></fleet-setup-favorites-setup>
            <fleet-setup-vendors-setup v-if="currentSection == 'vendors'"></fleet-setup-vendors-setup>
            <fleet-setup-activate v-if="currentSection == 'setup'"></fleet-setup-activate>

            <fleet-setup-step-summary :section="currentSection" @complete-step="completeStep"></fleet-setup-step-summary>


            <!-- Marketing content for section -->
            <section class="card mt-4" v-if="currentSection === 'team'">
                <div class="image-card">
                    <img title="Team Members" src="/accounts/img/vecteezy_man-having-a-conference-call-with-his-business-team-online_5514449.jpg" width="330" height="auto" />
                    <span class="td-circle-badge">1</span>
                </div>
                <div>
                    <h2 class="my-1 td-h4">Add Your Team</h2>
                    <p class="my-1 td-text-subdued">Invite your team members to collaborate.</p>
                    <div class="card-content">
                        <ul class="td-list my-2">
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Have Unlimited Users:</strong> Get your whole team on the system sharing all your notes, ratings, favorite and avoided vendors.</p>
                            </li>
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Share a Vendor:</strong> Easily share business information with your colleagues to keep everyone in the loop.</p>
                            </li>
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p>
                                    <strong class="td-text-secondary td-text-uppercase">Add Private Notes:</strong>
                                    Add private notes that always display in your search results to help you keep track of important details.
                                </p>
                            </li>
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Rate Service:</strong> Rate vendors to keep track of the quality service you receive and to help others in the community make informed decisions.</p>
                            </li>

                            <li class="list-item mt-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Avoid Vendors:</strong> Avoid any vendor in our system.  Any vendors you add to your avoid list will not show up in your search results.</p>
                            </li>

                        </ul>

                    </div>
                </div>
            </section>
            <section class="card mt-4" id="favorites" v-if="currentSection === 'favorites'">
                <div class="image-card">
                    <img title="Team Members" src="/accounts/img/vecteezy_logistics-and-distribution-network-with-delivery-trucks-and_73777967.jpg" width="350" height="auto" />
                    <span class="td-circle-badge">2</span>
                </div>
                <div>
                    <h2 class="my-1 td-h4">Add Favorite Networks</h2>
                    <p class="my-1 td-text-subdued">Connect your dealer networks and expand your reach.</p>
                    <div class="card-content">
                        <ul class="td-list my-2">
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Flag Your Favorite Networks:</strong> Your networks will show first in your searches.</p>
                            </li>
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Reduce Cost:</strong> Ensure you take advantage of any preferred fleet pricing you have or warranty work.</p>
                            </li>
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Improved Maintenance:</strong> Ensure you use consistent parts and service by using your favorite networks.</p>
                            </li>
                            <li class="list-item mt-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p>
                                    <strong class="td-text-secondary td-text-uppercase">Search Faster:</strong>
                                    Find approved and preferred vendors instantly without switching systems.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section id="vendors" class="card mt-4" v-if="currentSection === 'vendors'">
                <div class="image-card">
                    <img title="Team Members" src="/accounts/img/vecteezy_upload-file-with-cloud-storage-concept-illustration_10549844.jpg" width="350" height="auto" />
                    <span class="td-circle-badge">3</span>
                </div>
                <div>
                    <h2 class="my-1 td-h4">Import Vendors</h2>
                    <p class="my-1 td-text-subdued">Upload your vendor list to streamline operations.</p>
                    <div class="card-content">
                        <ul class="td-list my-2">
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Keep All Vendors in One Place:</strong> Centralize your verified vendors for easy access across your team.</p>
                            </li>
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Favorite Vendors First:</strong> Your favorite vendors always display first in searches close by them.</p>
                            </li>
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p>
                                    <strong class="td-text-secondary td-text-uppercase">Avoid Vendors:</strong>
                                    Vendors you add to your avoid list do not show in search results.
                                </p>
                            </li>
                            <li class="list-item my-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Search Faster:</strong> Find approved and preferred vendors instantly without switching systems.</p>
                            </li>

                            <li class="list-item mt-1">
                                <icon name="faCircleCheck" type="solid" class="td-text-secondary"></icon>
                                <p><strong class="td-text-secondary td-text-uppercase">Build a Smarter Network:</strong> Strengthen your vendor database over time as your fleet grows.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

        </main>
    </div>
</template>

<script>
import script from './FleetSetup';
    export default script;</script>

<style lang="less">
    @import "./FleetSetup.less";
</style>